<template>
  <div>
    <validation-observer ref="userDetailsValidation">
      <b-overlay :show="show_overlay" rounded="sm">
        <b-row class="d-flex align-items-start">
          <b-col class="col-md-3 col-12">
            <b-card>
              <b-col
                class="d-flex justify-content-between flex-column"
                cols="21"
              >
                <div
                  class="
                    d-flex
                    flex-column
                    align-items-center
                    justify-content-start
                  "
                >
                  <template>
                    <b-avatar :src="dataAvatar" rounded size="250px" />
                  </template>

                  <div class="d-flex flex-column ml-1">
                    <div class="d-flex mt-2 flex-wrap">
                      <b-form-file
                        :drop-placeholder="$t('upload')"
                        :browse-text="$t('upload')"
                        :placeholder="$t('choose_file_or_drop')"
                        :disabled="loading"
                        @input="fileInput"
                      />
                      <b-button
                        v-if="dataAvatar"
                        class="ml-auto mt-1"
                        variant="danger"
                        :disabled="loading"
                        @click="deletePhoto"
                      >
                        <feather-icon icon="TrashIcon" />
                        {{ $t("delete") }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-card>
          </b-col>

          <b-col class="col-md-6 col-12">
            <b-card>
              <b-row class="px-1">
                <b-col class="col-md-6 col-12">
                  <b-form-group :label="$t('user.username')" for="username">
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('phone')"
                      rules="required"
                    >
                      <b-form-input v-model="formData.username" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col class="col-md-6 col-12">
                  <b-form-group :label="$t('user.password')" for="password">
                    <b-input-group>
                      <b-form-input placeholder="············" readonly />
                      <b-input-group-append>
                        <b-button
                          v-b-modal.modal-password
                          variant="outline-primary"
                        >
                          {{ $t("change") }}
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-col cols="12">
                <b-form-group :label="$t('user.roles')" for="Roles">
                  <v-select
                    v-model="formData.role"
                    label="name"
                    :get-option-label="
                      (el) => {
                        return el.name[$i18n.locale];
                      }
                    "
                    :reduce="(role) => role.id"
                    :options="GET_ROLES"
                    multiple
                  />
                </b-form-group>
              </b-col>

              <b-row class="px-1">
                <b-col md="4">
                  <b-form-group :label="$t('status')" for="status">
                    <b-form-checkbox
                      v-model="formData.is_active"
                      class="mt-50"
                      inline
                      name="check-button"
                      switch
                    >
                      {{ formData.is_active ? $t("active") : $t("not_active") }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <b-col class="col-md-3 col-12 mb-2">
            <b-card>
              <b-form-group :label="$t('user.surname')">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('user.surname')"
                  rules="required"
                >
                  <b-form-input v-model="formData.last_name" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group :label="$t('contact.name')">
                <validation-provider
                  #default="{ errors }"
                  :name="$t('contact.name')"
                  rules="required"
                >
                  <b-form-input v-model="formData.first_name" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group :label="$t('user.middle_name')">
                <b-form-input v-model="formData.middle_name" />
              </b-form-group>

              <b-form-group :label="$t('phone')">
                  <cleave
                    id="phone"
                    class="form-control"
                    :raw="true"
                    :options="phoneOptions"
                    v-model="formData.phone_number"
                  />
              </b-form-group>
            </b-card>

            <div class="text-right">
              <b-button
                class="mr-2"
                variant="danger"
                :disabled="loading"
                @click="$router.push({name: 'users',})"
              >
                {{ $t("cancel") }}
              </b-button>
              <b-button
                variant="success"
                :disabled="loading"
                @click="updateUserData"
              >
                {{ $t("save") }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-overlay>
    </validation-observer>

    <EditPasswordModal />
  </div>
</template>

<script>
import {
  BAvatar,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BFormFile,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BOverlay,
  BRow,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import VSelect from "vue-select";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { min, required } from "@validations";
import EditPasswordModal from "./components/EditPasswordModal.vue";
import Cleave from "vue-cleave-component";
import i18n from "@/libs/i18n";
import loader from "@/mixins/loader";

extend("confirm", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: i18n.t("passwords_match_error"),
});

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormCheckbox,
    BInputGroupAppend,
    BFormFile,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    VSelect,
    EditPasswordModal,
    Cleave,
  },
  mixins: [togglePasswordVisibility, loader],
  data() {
    return {
      min,
      required,
      showError: false,
      loading: false,
      observer: null,
      contact: {},
      selectLoading: false,
      responseData: {},
      phoneOptions: {
        prefix: "998",
        blocks: [3, 2, 3, 2, 2],
        delimiter: " ",
      },
      photoFile: {},
      formData: {
        name: "",
        language: "ru",
        role: [],
        phone: "",
        theme: "",
        photo: null,
        is_active: false,
        username: "",
        last_name: "",
        first_name: "",
        phone_number: "",
        middle_name: "",
      },
      updateFormData: {},
      dataAvatar: "",
      show_overlay: false,
      status_options: [
        {
          title: "Active",
          value: 1,
        },
        {
          title: "Inactive",
          value: 0,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("users", [
      "GET_THEMES",
      "GET_LANGS",
      "GET_ROLES",
      "GET_USER",
      "GET_USER_PHONES",
    ]),
    ...mapGetters("contacts", ["getContactsList"]),
  },

  async mounted() {
    await this.$_loaderStart();
    this.loading = true;

    await this.FETCH_ROLES();

    await this.FETCH_SINGLE_USER({
      id: this.$route.params.id,
    });

    this.dataAvatar = this.GET_USER.photo;
    this.formData = this.GET_USER;

    this.responseData = Object.assign({}, this.GET_USER);

    this.loading = false;
  },
  async beforeRouteLeave(to, from, next) {
    await this.$_loaderStop();
    next();
  },
  watch: {},
  methods: {
    ...mapActions("users", [
      "UPDATE_USER",
      "UPLOAD_FILE",
      "FETCH_SINGLE_USER",
      "FETCH_ROLES",
    ]),
    ...mapActions("contacts", ["FETCH_ALL_CONTACTS_LIST"]),

    updateUserData() {
      this.$refs.userDetailsValidation.validate().then(async (success) => {
        if (!success) {
          return;
        }

        // Bu pastdagi kod agar phone_numberni required qilmoqchi bo'lsak ochishimiza kerak kommentdan
        // if (this.formData.phone_number.length < 12) {
        //   this.showError = true;
        //   return;
        // }

        this.loading = true;

        if (this.responseData.is_active != this.formData.is_active) {
          this.responseData.is_active = this.formData.is_active;
        } else {
          this.$delete(this.responseData, "is_active");
        }

        if (this.responseData.username != this.formData.username) {
          this.responseData.username = this.formData.username;
        } else {
          this.$delete(this.responseData, "username");
        }
        if (this.responseData.last_name != this.formData.last_name) {
          this.responseData.last_name = this.formData.last_name;
        } else {
          this.$delete(this.responseData, "last_name");
        }
        if (this.responseData.first_name != this.formData.first_name) {
          this.responseData.first_name = this.formData.first_name;
        } else {
          this.$delete(this.responseData, "first_name");
        }
        if ((this.responseData.phone_number != this.formData.phone_number) && (this.formData.phone_number != '998')) {
          this.responseData.phone_number = this.formData.phone_number;
        } else {
          this.$delete(this.responseData, "phone_number");
        }
        if (this.responseData.middle_name != this.formData.middle_name) {
          this.responseData.middle_name = this.formData.middle_name;
        } else {
          this.$delete(this.responseData, "middle_name");
        }
        if (this.responseData.role != this.formData.role) {
          this.responseData.role = this.formData.role;
        } else {
          this.$delete(this.responseData, "role");
        }

        if (this.contact) {
          this.responseData.contact = this.contact.id;
        }

        this.$delete(this.responseData, "photo");

        this.UPDATE_USER(this.responseData)
          .then(() => {
            this.$_okToast();

            this.$router.push("/users");

            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            this.$_errToast("Error");
          });
      });
    },

    updatePassword() {
      this.$refs.newPasswordValidation.validate().then(async (success) => {
        if (!success) {
          return;
        }

        try {
          await this.UPDATE_USER({
            id: this.$route.params.id,
            data: { password: this.password },
          });

          this.$_okToast();

          this.$nextTick(() => {
            this.$bvModal.hide("modal-password");
          });
        } catch (err) {
          this.$_errToast("Error");
        }
      });
    },

    async deletePhoto() {
      try {
        this.loading = true;
        await this.UPDATE_USER({
          photo: null,
          id: this.$route.params.id,
        });
        this.$_okToast();
        this.dataAvatar = "";
        this.photoFile = {};
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$_errToast("Error");
      }
    },

    async fileInput(file) {
      try {
        this.loading = true;

        if (file) {
          const formData = new FormData();

          formData.append("photo", file);
          formData.append("id", this.$route.params.id);

          const response = await this.UPDATE_USER(formData);
          this.dataAvatar = response.photo;
          this.$_okToast();
        }

        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$_errToast("Error");
      }
    },

    async onOpen() {
      if (this.getContactsList.next) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },

    onClose() {
      this.observer.disconnect();
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.loader {
  text-align: center;
  color: #bbbbbb;
}

#user_view_role ul {
  max-height: 150px !important;
}
</style>
